export default {
  first_name: 'Name',
  last_name: 'Last name',
  patronymic_name: 'Patronymic',
  birthdate: 'Birthdate',
  gender: 'Gender',
  country: 'Country of residence',
  city: 'City of residence',
  address: 'Address in Latin (used for equipment delivery)',
  address__hint: 'Country, City, Street, building and apartment/unit',
  address_postcode: 'Postcode',
  equipment_recipient: 'Full name of equipment recipient in Latin',
  phone: 'Phone',
  phone__hint: 'Active number for the courier',
  telegram: 'Telegram',
  telegram__hint:
    '@username or a t.me/username link. If you don’t have Telegram, share another messenger you use',
  contact_other: 'Additional contact',
  contact_other__hint: 'Messenger or private email',
  caption_emergency: 'Emergency contacts',
  caption_emergency__hintAbove:
    'It’s important for us to be ready to help you quickly in emergencies. Please provide at ' +
    'least one emergency contact we can reach if unexpected circumstances arise or we lose ' +
    'contact with you for a long time.',
  emergency_primary: 'Emergency contact (primary)',
  emergency_primary__hint:
    'Full name, relationship, phone and/or messenger. ' +
    'For example: Maria Ivanova, mother, +7 900 000-00-00, @maria',
  emergency_current_location: 'Emergency contact (in your current location)',
  emergency_current_location__hint:
    'Optional — someone near you in your current city/country. ' +
    'Same format: full name, relationship, phone and/or messenger',
  caption_emergency__hintBelow:
    'By submitting this form, you confirm that you have informed the emergency contacts listed ' +
    'above that their personal data (name, relationship, contact information) will be stored ' +
    'securely and used exclusively in emergency situations, and that they have given their ' +
    'consent to such use.',
  // ОРГАНИЗАЦИОННЫЕ ВОПРОСЫ
  contacts: 'Contact information',
  type_work: 'Preferred work format',
  type_work__hint: 'the office is relevant only if there is a company office in your city',
  office: 'Choose an office from your city:',
  office__hintBelow:
    'While quarantine remains in effect, new hires will begin working remotely, but once ' +
    'restrictions are lifted, it will be possible to work from an office',
  // ТЕХНИКА
  caption_technics: 'Questions about equipment',
  caption_technics__hintAbove: `
    Company provides each employee with work equipment (one set per employee). <br /><br />
    While we don't prohibit the use of personal equipment, we strongly recommend using corporate
    equipment with installed antivirus software and the latest updates.
    This is crucial for closing vulnerabilities, preventing threats, and complying with Compliance requirements. <br /><br />
    Equipment delivery to certain locations may be challenging and take considerable time.
    Therefore, please answer the question below whether you have personal equipment to start working with.
  `,
  need_hardware: 'Do you have personal equipment that you can use to start working?',
  need_hardware__hint:
    'Sometimes equipment delivery can be delayed, so it might not arrive by your first working day',
  existing_hardware: 'Enter the specifications of your laptop/PC',
  needed_hardware: 'Desired laptop OS and peripherals for work',
  needed_hardware__hint: `Please indicate below which operating system you prefer to work on — <b>macOS</b> or <b>Windows</b>. Also, indicate if you require additional peripherals (<b>mouse</b>, <b>monitor</b>, <b>keyboard</b>, etc.).</br>
    <b>Please note</b> that some teams use only one operating system — we will provide equipment based on our internal requirements, even if it differs from your request. We will notify you of the equipment you will receive after completing the form.`,
  has_hardware:
    'Do you have equipment you can use to get started while waiting for equipment from the company?',
  hardware_spec: 'What are the specifications of your work equipment?',
  hardware_spec__hint:
    'Specifications of your PC/laptop and OS version - we will verify whether the equipment is sufficient for your duties',
};
